<template>
    <div
        v-if="!section.hidden"
        class="mb-2 border-1 rounded-lg p-2 bg-white"
        :class="color == 'green' ? 'border-green' : 'border-red'"
    >
        <div class="flex justify-between items-center">
            <label
                :for="section.key"
                class="block text-sm font-medium text-gray-700"
            >
                {{ $translate(section.label) }}
            </label>
            <button @click="toggleOpen(section.key)" class="text-blue-500">
                {{ open[section.key] ? '−' : '+' }}
            </button>
        </div>
        <div v-if="open[section.key]" class="mt-2">
            <div
                v-for="(count, key) in section.items"
                :key="key"
                class="flex space-x-2"
            >
                <input
                    type="checkbox"
                    :id="`${section.key}-${key}`"
                    :value="key"
                    :checked="input[section.key].includes(key)"
                    @change="updateQuery(section.key, key)"
                    class="w-4 h-4"
                />
                <label :for="`${section.key}-${key}`">
                    <span v-if="section.transalateKey">
                        {{ $translate(section.transalateKey + '.' + key) }}
                    </span>
                    <span v-else>
                        {{ key }}
                    </span>
                    <span v-if="section.count">({{ count }})</span></label
                >
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    section: { type: Object, required: true },
    input: { type: Object, required: true },
    open: { type: Object, required: true },
    color: { type: String, default: 'red' },
});

const emits = defineEmits(['updateQuery', 'toggleOpen']);

const toggleOpen = key => {
    emits('toggleOpen', key);
};

const updateQuery = (key, value) => {
    emits('updateQuery', key, value);
};
</script>
<style lang="css">
label {
    font-size: 0.8rem;
    font-weight: 600;
    color: #374151;
    margin: 0;
}
</style>
